import { View } from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import { Button } from '@/components/ui/Button';
import { ThemedText, SubHeading, Body, Caption } from '@/components/ui/Text';
import { useTheme } from '@/theme';

type EmptyDocumentsStateProps = {
  onUpload: () => void;
  onManualEntry: () => void;
};

export function EmptyDocumentsState({ onUpload, onManualEntry }: EmptyDocumentsStateProps) {
  const theme = useTheme();
  
  return (
    <View
      style={{
        alignItems: 'center',
        justifyContent: 'center',
        paddingVertical: theme.spacing(8),
        paddingHorizontal: theme.spacing(4),
        gap: theme.spacing(3),
        flex: 1,
      }}
    >
      <View
        style={{
          width: 140,
          height: 140,
          borderRadius: theme.radii.xl,
          backgroundColor: theme.colors.primary + '12',
          alignItems: 'center',
          justifyContent: 'center',
          borderWidth: 2,
          borderColor: theme.colors.primary + '25',
          marginBottom: theme.spacing(1),
        }}
      >
        <Ionicons name="document-text-outline" size={72} color={theme.colors.primary} />
      </View>
      
      <View style={{ gap: theme.spacing(1), alignItems: 'center' }}>
        <SubHeading style={{ textAlign: 'center', fontSize: 22, lineHeight: 28 }}>
          Your secure documents vault
        </SubHeading>
        
        <Body
          color={theme.colors.textSecondary}
          style={{
            textAlign: 'center',
            maxWidth: 300,
            lineHeight: 22,
            fontSize: 15,
          }}
        >
          Store your passports, visas, and travel documents securely. All files are encrypted and protected with biometric access.
        </Body>
      </View>
      
      <View
        style={{
          flexDirection: 'row',
          alignItems: 'center',
          gap: theme.spacing(1),
          paddingHorizontal: theme.spacing(2),
          paddingVertical: theme.spacing(1.5),
          backgroundColor: theme.colors.primary + '08',
          borderRadius: theme.radii.lg,
          marginTop: theme.spacing(1),
        }}
      >
        <Ionicons name="shield-checkmark" size={18} color={theme.colors.primary} />
        <Caption color={theme.colors.primary} style={{ fontWeight: '600' }}>
          End-to-end encrypted
        </Caption>
      </View>
      
      <View style={{ gap: theme.spacing(1.5), width: '100%', marginTop: theme.spacing(3), maxWidth: 360 }}>
        <Button
          label="Upload document"
          onPress={onUpload}
          icon={<Ionicons name="add-circle-outline" size={22} color={theme.colors.surface} />}
          style={{
            paddingVertical: theme.spacing(2),
          }}
        />
        <Button
          label="Add manual entry"
          variant="secondary"
          onPress={onManualEntry}
          icon={<Ionicons name="create-outline" size={20} color={theme.colors.primary} />}
          style={{
            paddingVertical: theme.spacing(2),
          }}
        />
      </View>
    </View>
  );
}

